import { Loader } from 'rsuite';

export const CustomLoader = () => {
  return (
    <div className="flex w-full justify-center items-center min-h-[40vh]">
      <Loader size="md" />
    </div>
  );
};
